var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("g", { attrs: { transform: "translate(3.705 2.9)" } }, [
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M1.087 15.678H.566a.521.521 0 0 1-.521-.521V.567c0-.287.233-.52.52-.52h.522c.288 0\n          .521.233.521.52v14.59a.521.521 0 0 1-.521.52",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", { attrs: { transform: "translate(.579 2.9)" } }, [
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M1.042 15.678h-.52A.521.521 0 0 1 0 15.157V.567C0 .28.233.047.521.047h.521c.288 0\n          .521.233.521.52v14.59a.521.521 0 0 1-.52.52",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", { attrs: { transform: "translate(6.884 2.9)" } }, [
          _c("path", {
            attrs: {
              fill: _vm.color,
              d: "M1.598 13.904l2.851-3.593 2.042 2.453L9.343 9.09l3.661 4.813H1.598zm1.774-10.51a1.693 1.693 0 1 1 0 3.387\n          1.693 1.693 0 0 1 0-3.387zM14.016.046H.556a.521.521 0 0 0-.521.521v14.596c0 .287.233.52.52.52h13.461a.521.521\n          0 0 0 .521-.52V.567a.521.521 0 0 0-.52-.52z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("path", { attrs: { d: "M0 0h21.621v21.621H0z" } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }